import { render, staticRenderFns } from "./SurveyStatisticsDetailModalView.vue?vue&type=template&id=5f83df76&scoped=true"
import script from "./SurveyStatisticsDetailModalView.ts?vue&type=script&lang=ts&external"
export * from "./SurveyStatisticsDetailModalView.ts?vue&type=script&lang=ts&external"
import style0 from "./SurveyStatisticsDetailModalView.vue?vue&type=style&index=0&id=5f83df76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f83df76",
  null
  
)

export default component.exports